import { MetricUId } from "../../Metrics/constants"
import getChartConfigTemplate from "../Templates/StackedBarChart/utils";
import { mergeProps } from "../../../generic/Utils/mergeProps";

const metricColorMap = {
  [MetricUId.MENTEES_WHO_SENT_MEETING_REQUEST_BUT_NEVER_CONNECTED_ONE_TIME]: "#0969DA",
  [MetricUId.MENTEES_WHO_HAVENT_SENT_MEETING_REQUEST_AND_NEVER_CONNECTED_ONE_TIME]: "#FA5F5F"
}

const getChartConfig = function(props = {}) {
  const mergedProps = mergeProps(props, {
    seriesMetricsUids: [MetricUId.MENTEES_WHO_SENT_MEETING_REQUEST_BUT_NEVER_CONNECTED_ONE_TIME, MetricUId.MENTEES_WHO_HAVENT_SENT_MEETING_REQUEST_AND_NEVER_CONNECTED_ONE_TIME],
    metricColorMap: metricColorMap
  });

  return getChartConfigTemplate(mergedProps);
};

export default getChartConfig;